import React, { useState } from "react"
import { Button } from "react-bootstrap"
import { injectIntl } from "react-intl"
import Checkbox from "../../common/checkbox/checkbox.component"
import { Redirect } from "react-router-dom"
import { START_UP_GUIDE_OPTION, START_UP_GUIDE_TYPE } from "../../state/onboarding/DataFlowTypes"
import { GUIDE_CHECKLIST_OPTIONS } from "../../state/onboarding/DataFlowMaps"
import Icon from "../../common/icon/icon.component"
import { Intl } from "../../state/helpers/IntlProps"

type OwnProps = {
    intl: Intl,
    guideKeys: Array<START_UP_GUIDE_OPTION>
    completedGuides: Set<START_UP_GUIDE_OPTION>
    modalStyle: string
    onCheckCallBack: (isCompleted: START_UP_GUIDE_OPTION) => void
}

const GuideChecklistComponent = (props: OwnProps) => {
    const [redirect, setRedirect] = useState(<></>)

    const showArticleOnClick = (articleID: number): void => {
        // @ts-ignore
        window.Intercom("showArticle", articleID)
    }

    const redirectOnClick = (url: string): void => {
        setRedirect(<Redirect to={url} />)
    }

    const getListItemClass = (isCompleted: boolean): string => {
        const baseClass = "list-group-item d-flex align-items-center text-left "
        if (isCompleted) {
            return baseClass.concat("list-group-item-success")
        }
        return baseClass
    }

    return (
        <ul className="list-group">
            {redirect}
            {props.guideKeys.map(key => {
                const isCompleted = props.completedGuides.has(key)
                return (
                    <li key={key} className={getListItemClass(isCompleted)}>
                        <Checkbox
                            id={key}
                            className={"mr-3"}
                            checked={props.completedGuides.has(key)}
                            onChange={() => props.onCheckCallBack(key)}
                        />

                        <div className={"mr-auto"} style={isCompleted ? { textDecoration: "line-through" } : {}}>
                            <label className={"d-inline"} htmlFor={key}>
                                {props.intl.formatMessage(GUIDE_CHECKLIST_OPTIONS[key].descriptionMessage)}
                            </label>
                        </div>

                        {GUIDE_CHECKLIST_OPTIONS[key] && GUIDE_CHECKLIST_OPTIONS[key].guides.map(guide => {
                            switch (guide.guideType) {
                            case START_UP_GUIDE_TYPE.INTERCOM_ARTICLE:
                                return <div className={"m-2 mt-2"}>
                                    <Button className={"btn-sm"}
                                        onClick={() => showArticleOnClick(guide.articleID)}>
                                        <Icon value={"book"} className={"mr-1"} />
                                        {props.intl.formatMessage(guide.guideLabel)}
                                    </Button>
                                </div>

                            case START_UP_GUIDE_TYPE.REDIRECT:
                                return <div className={"m-2 mt-2"}>
                                    <Button className={"btn-sm"}
                                        onClick={() => redirectOnClick(guide.redirectUrl)}>
                                        <Icon value={"cog"} className={"mr-1"} />
                                        {props.intl.formatMessage(guide.guideLabel)}
                                    </Button>
                                </div>
                            }
                        })}
                    </li>
                )
            })}
        </ul>
    )
}

export default injectIntl(GuideChecklistComponent)


// WEBPACK FOOTER //
// ./src/onboarding/components/GuideChecklistComponent.tsx